import React, {Component, useState} from 'react'
// import Hot from '../../Components/Hot/Hot'
// import Notice from '../../Components/Notice/Notice'
import news_name from '../../Pic/news.png'
import hot_news from '../../Pic/hot.png'
import news_notice from '../../Pic/notice.png'
import sort1 from '../../Pic/sort-1.png'
import sort2 from '../../Pic/sort-2.png'
import sort3 from '../../Pic/sort-3.png'
import sort4 from '../../Pic/sort-4.png'
import sort5 from '../../Pic/sort-5.png'
import tag_hot from '../../Pic/tag-hot.png'
import icon_edit from '../../Pic/icon-edit.png'
import icon_delete from '../../Pic/icon-delete.png'
import './News.css'
import Newspart from './Newspart'
import {Pagination} from 'antd';
import 'antd/dist/antd.css';
import Header from '../Header/Header'
import Axios from 'axios'
import {Link} from 'react-router-dom'
import moment from 'moment'
import {deleteNotice} from '../../service/action'


export default class News extends Component {
    state = {
        // listData: [  //fake data
        //     {
        //         id: '001',
        //         title: '不要温和地走进那个良夜',
        //         summary: '不要温和地走进那个良夜，老年应当在日暮时燃烧咆哮；怒斥，怒斥光明的消逝。',
        //         content: 'ghjkl'
        //     }
        // ],
        listData: [], hotData: [], noticeData: [], currentNewPage: 1,//当前新闻所在页面
        currentNoticePage: 1,//当前公告所在页面
        total: 0,//新闻总条数
        noticeTotal: 0,//公告总条数
    }

    async componentDidMount() {
        Axios.get(`${global.url.news}/news/page2`)   // ---  -- 换成我
            // Axios.get('../../data/newsdata.json')
            .then(res => {
                this.setState({
                    listData: res.data.payload.records, total: res.data.payload.total
                })
            })
        // Axios.get(`${global.url.news}/news/getNews/5/1`)   // ---  -- 换成热门
        Axios.get(`${global.url.news}/news/page3`)   // ---  -- 换成热门
            // Axios.get('../../data/newsdata.json')
            .then(res => {
                console.log('热点数据:', res)
                this.setState({
                    hotData: res.data.payload
                })
            })
        Axios.get(`${global.url.news}/notice/page?page=1&limit=5`)   // ---  -- 换成公告
            // Axios.get('../../data/newsdata.json')
            .then(res => {
                // debugger
                // console.log(res)
                this.setState({
                    noticeData: res.data.payload.records, noticeTotal: res.data.payload.total,
                }, () => {
                })
            })
    }

    onChange = (page, pagesize) => {//新闻切换页面
        // console.log(page);
        ////进行数据的读取
        Axios.get(`${global.url.news}/news/page2?page=${page}&limit=10`)   // ---  -- 换成我
            // Axios.get('../../data/newsdata.json')
            .then(res => {
                this.setState({
                    listData: res.data.payload.records, // total: res.data.payload.total,
                    currentNewPage: page
                })
            })
    }
    onNoticeChange = (page, pagesize) => {//公告切换页面
        // console.log(page);
        ////进行数据的读取
        Axios.get(`${global.url.news}/notice/page?page=${page}&limit=5`)
            .then(res => {
                // console.log(res)
                this.setState({
                    noticeData: res.data.payload.records, // noticeTotal: res.data.payload.total,
                    currentNoticePage: page
                })
            })
    }
    jump2Editor = (data) => {
        this.props.history.push({
            state: data, pathname: `/ManagerCenter/NewsEditorTest/news`
        })
    }

    jumpEditor = (data) => {
        // debugger
        this.props.history.push({
            state: data, pathname: `/ManagerCenter/NewsEditorTest/notice`
        })
    }

    searchTheNewsOrNotice = async (value) => {
        // console.log("xxxxxxxxxxxxx")
        // console.log(value)
        if (value) {
            const {data: res} = await Axios.get(`${global.url.news}/news/selectByTitle?title=${value}`)
            if (res.code === '200') {
                this.setState({
                    listData: res.payload, total: res.payload.length
                }, () => {
                    console.log(this.state.listData)
                })
            } else {
                this.setState({
                    listData: [], total: 0
                })
            }
        } else {
            Axios.get(`${global.url.news}/news/page2`)   // ---  -- 换成我
                // Axios.get('../../data/newsdata.json')
                .then(res => {
                    this.setState({
                        listData: res.data.payload.records, total: res.data.payload.total
                    })

                })
        }

    }

    render() {

        let {listData} = this.state


        return (<div className='newsBox'>
            <Header searchTheNewsOrNotice={(value) => this.searchTheNewsOrNotice(value)}></Header>
            {/* 主要的新闻展示 */}
            <div className="news_content">
                <div id='newscenter'>
                    {/* 装饰线 */}
                    <div className='decoration_news'>
                        <div id='decorationBox'></div>
                        <img className='news_name' src={news_name} alt=''></img>
                        {/* <div className="news-total-number">共{this.state.total > 10000 ? "1万+" : this.state.total}条新闻</div> */}
                    </div>

                    <div id="divider"></div>
                    {/* 新闻列表 */}
                    <div className='news_space_list'>
                        {listData.map((data, index) => {
                            // console.log(data);
                            let newsTag;
                            let newsText;
                            {
                                if (data.source == '1') {
                                    newsTag = 'news_tag_self_transfer';
                                    newsText = '转载'
                                } else {
                                    newsTag = 'news_tag_self';
                                    newsText = '自主'
                                }
                            }
                            return <Newspart key={data.id} data={data} jump2Editor={this.jump2Editor}
                                             newsTag={newsTag} newsText={newsText}/>
                        })}

                        <div className='pagination_space'>
                            <Pagination total={this.state.total} current={this.state.currentNewPage}
                                        onChange={this.onChange.bind(this)} showSizeChanger={false}/>
                        </div>
                        <div style={{width: '100%', height: '100px'}}></div>
                    </div>
                </div>
                <div id='right_news_notice'>
                    <div>
                        <div id='decoration_hot_news'>
                            <img src={hot_news} alt=''></img>
                            <div id='decorationBox'></div>
                        </div>
                        <div id='devider_hot_news'></div>
                        <div id='hot_news_list'>
                            <ul>
                                {this.state.hotData && this.state.hotData.map((data, index) => {
                                    let imgs;
                                    switch (index) {
                                        case 1:
                                            imgs = sort2
                                            break;
                                        case 2:
                                            imgs = sort3
                                            break;
                                        case 3:
                                            imgs = sort4
                                            break;
                                        case 4:
                                            imgs = sort5
                                            break;
                                        default:
                                            imgs = sort1
                                    }
                                    return (<Link to={`/NewsBulletin/NewsDetail/${data.id}`}>
                                        <li id='sore01' key={data.id}>
                                            <img id='hot_news_sort_num' src={imgs} alt=''></img>
                                            <a className='title_news'>{data.title}</a>
                                            <p className='time_news'>{moment(data.created).format("YYYY-MM-DD HH:mm:ss")}</p>
                                            <img className='news_tag_hot' src={tag_hot} alt=''></img></li>
                                    </Link>)
                                })}
                            </ul>
                        </div>
                    </div>


                    <div id='notice_rightPart'>
                        <div id='decoration_hot_news'>
                            <img src={news_notice} alt=''></img>
                            <div id='decorationBox'></div>
                            {/* <div className="notice_total_number">共{this.state.noticeTotal > 100 ? "100+" : this.state.noticeTotal}条公告</div> */}
                        </div>

                        <div id='devider_hot_news'></div>

                        <ul>
                            {this.state.noticeData.map((data) => {
                                return (

                                    <li id='notice_rightPart_list'>
                                        {/* <p className='title_notice'>{data.title}</p> */}
                                        <div className="notice_content">
                                            <Link className='title_notice'
                                                  to={`/NewsBulletin/Notice/${data.id}`}>{data.title}</Link>
                                            {/* <div className="notice-author">编者：{data.author}</div> */}
                                            <div className="notice_diver"></div>
                                            <p className='time_notice'>{moment(data.created).format("YYYY-MM-DD HH:mm:ss")}</p>
                                            <div className='text_notice_oneline'
                                                 dangerouslySetInnerHTML={{__html: data.content}}></div>
                                        </div>
                                        {/* <div className='edit-news'>
                                                    <div className={'icon_edit'}
                                                        onClick={() => this.jumpEditor(data)}
                                                    ></div>
                                                    <div className={'icon_delete'}
                                                        onClick={async () => {
                                                            await deleteNotice(data.id)
                                                            window.location.reload()
                                                        }}
                                                    ></div>
                                                </div> */}
                                    </li>

                                )
                            })}

                        </ul>
                        <div className='pagination_position'>
                            <Pagination defaultPageSize={5} total={this.state.noticeTotal}
                                        current={this.state.currentNoticePage}
                                        onChange={this.onNoticeChange.bind(this)}/>
                            {/* <Pagination total={this.state.total} current={this.state.currentNewPage} onChange={this.onChange.bind(this)} /> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }
}
